import React, { useContext, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';

import { AppContext } from '../contexts/app.context';
import Button from './button';

import europeLogo from '../assets/logos/europe.svg';
import wsfLogo from '../assets/logos/wsf.svg';
import quadriLogo from '../assets/logos/quadri.svg';

const BaseContainer = () => {
  const {
    baseContainerConfig: {
      heading,
      subHeading,
      buttonText,
      buttonURL,
      buttonCallback,
      showFooter = true,
    } = {},
  } = useContext(AppContext);

  const baseContainerRef = useRef(null);
  const footerRef = useRef(null);

  useEffect(() => {
    if (!showFooter) return;

    const updateFooterPosition = () => {
      const screenHeight = window.innerHeight;
      const baseContainerHeight = baseContainerRef.current.offsetHeight;
      const footerHeight = footerRef.current.offsetHeight;

      if (screenHeight < baseContainerHeight + footerHeight + 100) {
        footerRef.current.style.position = '';
        return;
      }

      footerRef.current.style.position = 'absolute';
      footerRef.current.style.bottom = '0';
      footerRef.current.style.width = '100%';
      footerRef.current.style.left = '0';
      footerRef.current.style.right = '0';
    };

    updateFooterPosition();

    window.addEventListener('resize', updateFooterPosition);

    return () => window.removeEventListener('resize', updateFooterPosition);
  }, [baseContainerRef, footerRef, showFooter, heading, subHeading, buttonText]);

  return (
    <div className="w-full bg-white min-h-dvh">
      <div className="flex flex-row h-6">
        <div className="bg-blue-10 w-[40%] h-full" />
        <div className="bg-white w-[25%] h-full" />
        <div className="bg-red-20 w-[35%] h-full" />
      </div>
      <div ref={baseContainerRef} className="py-20 px-2 container mx-auto">
        <div className="flex flex-row justify-between items-center flex-wrap gap-6">
          <div className="w-auto">
            {heading && (
              <h1
                className="text-4xl font-extrabold text-blue-10"
                dangerouslySetInnerHTML={{ __html: heading }}
              />
            )}
            {subHeading && (
              <p
                className="text-lg text-blue-10"
                dangerouslySetInnerHTML={{ __html: subHeading }}
              />
            )}
          </div>
          {buttonText && <Button text={buttonText} url={buttonURL} callback={buttonCallback} />}
        </div>
        <div className="mt-12">
          <Outlet />
        </div>
      </div>

      {showFooter && (
        <div
          ref={footerRef}
          style={{ display: showFooter ? 'flex' : 'none' }}
          className="flex items-center justify-center p-6 gap-6 flex-wrap mt-16 border-t border-black bg-gray-70">
          <img src={wsfLogo} alt="WSF" className="w-32 h-auto" />
          <img src={quadriLogo} alt="Quadri" className="w-32 h-auto" />
          <img src={europeLogo} alt="Europe" className="w-32 h-auto" />
        </div>
      )}
    </div>
  );
};

export default BaseContainer;
